import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/tmp/seed/source/apps/web/app/(normal)/clientLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/tmp/seed/source/apps/web/app/(providers)/PostHogProvider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/app/sign-up/layout.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/tmp/seed/source/apps/web/lib/theme.ts");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Notifications"] */ "/tmp/seed/source/node_modules/@mantine/notifications/esm/Notifications.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/seed/source/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/node_modules/next/font/google/target.css?{\"path\":\"lib/fonts.ts\",\"import\":\"JetBrains_Mono\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-mono\"}],\"variableName\":\"fontMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/tmp/seed/source/node_modules/nuqs/dist/adapters/next/app.js");
